import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfigService } from 'src/app/core/services/api-config/api-config.service';
import {
  ApplicationFormForCodeType,
  ApplicationFormType,
  RegisterInfoResponse,
} from 'src/app/shared/types/registration.type';

@Injectable({
  providedIn: 'root',
})
export class RegistrationService {
  constructor(
    private http: HttpClient,
    private ApiConfigService: ApiConfigService
  ) {}

  private get baseUrl(): string {
    return `${this.ApiConfigService.apiUrl}/registration`;
  }

  getRegisterInfo(): Observable<RegisterInfoResponse> {
    return this.http.get<RegisterInfoResponse>(`${this.baseUrl}/info`);
  }

  register(body: ApplicationFormForCodeType): Observable<{ data: any }> {
    return this.http.post<{ data: any }>(`${this.baseUrl}/register`, body);
  }

  registerConfirm(body: ApplicationFormType): Observable<{ data: any }> {
    return this.http.post<{ data: any }>(
      `${this.baseUrl}/register-confirm`,
      body
    );
  }

  verifyToken(token: string) {
    return this.http.get(`${this.baseUrl}/verification?token=${token}`);
  }
}
